import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=7fa34b2c&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "../../../less/bulletin.less?vue&type=style&index=0&id=7fa34b2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa34b2c",
  null
  
)

export default component.exports